// Module
var code = "<h2 id=\"press-releases\">Press Releases</h2> <p>Stay up to date with official statements made to the media from PHEAA.</p> ";
// Exports
export default code;